// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-picker-caption[data-v-4d040dce]:not(:first-child){margin-top:0}`, "",{"version":3,"sources":["webpack://./src/components/Member/MemberSearchResults.vue"],"names":[],"mappings":"AAEC,0DACC,YAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
